<template>
    <div class="page-width">
      <div class='four-o-four'>
        <h1 class='title'>404</h1>
        <p class='sorry'>{{ $t('doesNotExist') }}</p>
      </div>
    </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  name: 'confirmation',
  created() {
  },
}
</script>

<style scoped lang="less">
@import "../assets/css/public.less";
@import "../assets/css/404.less";
</style>



// WEBPACK FOOTER //
// src/view/404.vue